import React, {
  forwardRef,
  LegacyRef,
  useCallback,
  useEffect,
  useState,
} from "react";
import { IconProps, useApiProps } from "../icon";
// import "../style/css";

const SettingIcon = forwardRef<SVGSVGElement, IconProps>(
  (props: IconProps, ref: LegacyRef<SVGSVGElement>) => {
    const {
      colors = [],
      className,
      id = "",
      hover = "",
      size,
      disabled = false,
      style,
      color,
      onMouseEnter,
      onMouseLeave,
      ...resultProps
    } = props;
    //@ts-ignore
    const { sizeStyle, cls } = useApiProps({
      className,
      initColor: ["currentColor","white"],
      initName: "setting",
      colors,
      id,
      hover,
      size,
      style,
      disabled,
      color,
    });
    // 默认的color 列表
    const [colorList, setColorList] = useState(["currentColor","white"]);
    const [colorsProps, setColorsProps] = useState(["currentColor","white"]);
    const [defaultColor, _] = useState(["currentColor","white"]);

    useEffect(() => {
      if (typeof colors === "string" && "setting".indexOf("-colored") === -1) {
        const col = JSON.parse(JSON.stringify(["currentColor","white"]));
        const find = col.find((item) => item === "currentColor");
        let _col = col;
        if (find) {
          _col = col.map((item) => {
            if (item === "currentColor") {
              item = colors;
            }
            return item;
          });
        } else {
          _col[0] = colors;
        }
        setColorList(_col);
        setColorsProps(_col);
      }

      // 如果colors 是数组
      if (colors instanceof Array && "setting".indexOf("-colored") === -1) {
        // 获取数组中的对象
        const colorList1 = JSON.parse(JSON.stringify(["currentColor","white"]));
        colors.forEach((col) => {
          // 获取到修改的元素
          const findColorIndex = colorList1.findIndex(
            (v) => v === col.targetColor
          );
          if (findColorIndex >= 0) {
            colorList1[findColorIndex] = col.reviseColor;
          }
        });
        setColorList([...colorList1]);
        setColorsProps([...colorList1]);
      }

      if (
        color &&
        typeof color === "string" &&
        "setting".indexOf("-colored") === -1
      ) {
        const col = JSON.parse(JSON.stringify(["currentColor","white"]));
        const find = col.find((item) => item === "currentColor");
        let _col = col;
        if (find) {
          _col = col.map((item) => {
            if (item === "currentColor") {
              item = color;
            }
            return item;
          });
        } else {
          _col[0] = color;
        }
        setColorList(_col);
        setColorsProps(_col);
      }
    }, [JSON.stringify(colors), color, defaultColor]);

    const handleMouseEnter = useCallback(
      (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        onMouseEnter && onMouseEnter(event);
        if (!hover || hover.length === 0) return;
        if (colors instanceof Array && "setting".indexOf("-colored") === -1) {
          if (hover instanceof Array && "setting".indexOf("-colored") === -1) {
            // 获取数组中的对象
            const colorList1 = JSON.parse(JSON.stringify(colorList));
            hover.forEach((col) => {
              // 获取到修改的元素
              const findColorIndex = colorList1.findIndex(
                (v) => v === col.targetColor
              );
              if (findColorIndex >= 0) {
                colorList1[findColorIndex] = col.reviseColor;
              }
            });
            setColorList([...colorList1]);
          }
        }

        if (typeof colors === "string" && "setting".indexOf("-colored") === -1) {
          if (typeof hover === "string") {
            const col = JSON.parse(JSON.stringify(colorList));
            const find = col.find((item) => item === colors);
            let _col = col;
            if (find) {
              _col = col.map((item) => {
                if (item === colors) {
                  item = hover;
                }
                return item;
              });
            } else {
              _col[0] = hover;
            }
            setColorList(_col);
          }
        }

        if (
          color &&
          typeof color === "string" &&
          "setting".indexOf("-colored") === -1
        ) {
          if (typeof hover === "string") {
            const col = JSON.parse(JSON.stringify(colorList));
            const find = col.find((item) => item === color);
            let _col = col;
            if (find) {
              _col = col.map((item) => {
                if (item === color) {
                  item = hover;
                }
                return item;
              });
            } else {
              _col[0] = hover;
            }
            setColorList(_col);
          }
        }

        if (
          !color &&
          colors.length === 0 &&
          typeof hover === "string" &&
          "setting".indexOf("-colored") === -1
        ) {
          const col = JSON.parse(JSON.stringify(colorList));
          const find = col.find((item) => item === "currentColor");
          let _col = col;
          if (find) {
            _col = col.map((item) => {
              if (item === "currentColor") {
                item = hover;
              }
              return item;
            });
          } else {
            _col[0] = hover;
          }
          setColorList(_col);
        }

        if (
          !color &&
          colors.length === 0 &&
          hover instanceof Array &&
          "setting".indexOf("-colored") === -1
        ) {
          // 获取数组中的对象
          const colorList1 = JSON.parse(JSON.stringify(colorList));
          hover.forEach((col) => {
            // 获取到修改的元素
            const findColorIndex = colorList1.findIndex(
              (v) => v === col.targetColor
            );
            if (findColorIndex >= 0) {
              colorList1[findColorIndex] = col.reviseColor;
            }
          });
          setColorList([...colorList1]);
        }
      },
      [colorList, defaultColor, colors, color, hover]
    );

    const handleMouseLeave = useCallback(
      (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        onMouseLeave && onMouseLeave(event);
        if (!hover || hover.length === 0) return;
        let _defaultColor = JSON.parse(JSON.stringify(defaultColor));
        if (colorsProps) {
          _defaultColor = JSON.parse(JSON.stringify(colorsProps));
        }
        setColorList(_defaultColor);
      },
      [colorsProps, defaultColor, hover]
    );

    return <svg id="setting"  style={sizeStyle}  className={cls}  ref={ref}  onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...resultProps}  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_1275)"><path d="M6.0773 0.666687H9.92332L10.3688 2.81846C10.7471 2.98132 11.1043 3.18201 11.4353 3.41567L13.5858 2.71289L15.5289 5.96413L13.8127 7.42119C13.8326 7.61167 13.8428 7.80478 13.8428 8.00002C13.8428 8.19526 13.8326 8.38838 13.8127 8.57886L15.5289 10.0359L13.5858 13.2872L11.4353 12.5844C11.1043 12.818 10.7471 13.0187 10.3688 13.1816L9.92332 15.3334H6.0773L5.63181 13.1816C5.25355 13.0187 4.89633 12.818 4.56532 12.5844L2.4148 13.2872L0.47168 10.0359L2.18795 8.57886C2.168 8.38838 2.1578 8.19526 2.1578 8.00002C2.1578 7.80478 2.168 7.61167 2.18795 7.42119L0.47168 5.96413L2.4148 2.7129L4.56531 3.41567C4.89632 3.18201 5.25354 2.98132 5.63181 2.81846L6.0773 0.666687ZM7.16287 2.00002L6.78834 3.80905L6.43501 3.93476C5.94656 4.10854 5.49826 4.36132 5.10668 4.6766L4.82511 4.9033L3.01294 4.31109L2.19561 5.67866L3.62214 6.88974L3.55535 7.2666C3.51317 7.50457 3.49113 7.74956 3.49113 8.00002C3.49113 8.25048 3.51317 8.49547 3.55535 8.73345L3.62214 9.11031L2.19561 10.3214L3.01294 11.689L4.82512 11.0968L5.10669 11.3235C5.49827 11.6387 5.94656 11.8915 6.43501 12.0653L6.78834 12.191L7.16287 14H8.83775L9.21229 12.191L9.56561 12.0653C10.0541 11.8915 10.5024 11.6387 10.8939 11.3235L11.1755 11.0968L12.9877 11.689L13.805 10.3214L12.3785 9.11031L12.4453 8.73345C12.4874 8.49547 12.5095 8.25048 12.5095 8.00002C12.5095 7.74956 12.4874 7.50457 12.4453 7.2666L12.3785 6.88974L13.805 5.67866L12.9877 4.31109L11.1755 4.9033L10.8939 4.6766C10.5024 4.36132 10.0541 4.10854 9.56561 3.93476L9.21229 3.80905L8.83775 2.00002H7.16287ZM8.00031 6.66669C7.26393 6.66669 6.66698 7.26364 6.66698 8.00002C6.66698 8.7364 7.26393 9.33335 8.00031 9.33335C8.73669 9.33335 9.33364 8.7364 9.33364 8.00002C9.33364 7.26364 8.73669 6.66669 8.00031 6.66669ZM5.33364 8.00002C5.33364 6.52726 6.52755 5.33335 8.00031 5.33335C9.47307 5.33335 10.667 6.52726 10.667 8.00002C10.667 9.47278 9.47307 10.6667 8.00031 10.6667C6.52755 10.6667 5.33364 9.47278 5.33364 8.00002Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_1275"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>;
  }
);

SettingIcon.displayName = "SettingIcon";

export default SettingIcon;
